import axios from 'axios'
import Cookies from 'js-cookie'
import { getAnonId } from './anonSession'

const API_URL = process.env.REACT_APP_API_URL

// Authenticated event — requires a valid JWT cookie.
export const logEvent = async ({ action, content }) => {
  const token = Cookies.get('token')
  if (!token) return
  try {
    await axios.post(
      `${API_URL}/logs/behavior`,
      { action, content },
      { headers: { Authorization: `Bearer ${token}` } }
    )
  } catch (err) {
    console.error('Failed to log event:', err)
  }
}

// Anonymous event — for non-logged-in users (homepage, landing pages).
// Never sends the user's token; identifies the browser via a stable UUID.
export const logAnonEvent = async ({ action, content }) => {
  try {
    const anon_id = getAnonId()
    await axios.post(`${API_URL}/logs/anon`, { anon_id, action, content })
  } catch {
    // Analytics must never break the UX — fail silently.
  }
}
